const ReviewItemBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="#333" />
    <rect x="2" y="2" width="20" height="20" fill="#ffd400" />
    <rect x="4" y="10" width="16" height="4" fill="#fff" />
    <rect x="4" y="10" width="12" height="4" fill="#333" />
  </svg>
);

export default ReviewItemBlockIcon;
